import Wrapper from './wrapper';
import { ITokenizerVersions, IWrapper } from './types';

class Tokenizer {
  wrapper: IWrapper;
  /**
   * @param {Wrapper} wrapper
   */
  constructor(wrapper: Wrapper) {
    this.wrapper = wrapper;
  }

  versions() {
    return this.wrapper.client.get<ITokenizerVersions, ITokenizerVersions>(
      `tokenizer-versions/?advanced=true`
    );
  }
}

export default Tokenizer;
